import React, { createContext, useMemo, useState } from 'react';

const defaultContext = {
  isNavigationSticky: false,
  setNavigationSticky: (_: boolean) => {}
};

export type NavigationStickyContextType = typeof defaultContext;

const NavigationStickyContext =
  createContext<NavigationStickyContextType>(defaultContext);

export function NavigationStickyContextProvider({
  children
}: React.PropsWithChildren) {
  const [isNavigationSticky, setNavigationSticky] = useState(
    defaultContext.isNavigationSticky
  );

  const value = useMemo<NavigationStickyContextType>(
    (): NavigationStickyContextType => ({
      isNavigationSticky,
      setNavigationSticky
    }),
    [isNavigationSticky]
  );

  return (
    <NavigationStickyContext.Provider value={value}>
      {children}
    </NavigationStickyContext.Provider>
  );
}

NavigationStickyContextProvider.displayName = 'NavigationStickyContextProvider';

export default NavigationStickyContext;
